module.exports = __webpack_public_path__ + "img/5.16885ce8.jpg";